export default "__VITE_ASSET__15f41243__"